module.exports = __webpack_public_path__ + "static/media/envelop4.3ccd2605.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/envelop4.svg
// module id = 2794
// module chunks = 7